import styles from "./Topbanner.module.scss";

export default function Topbanner(props) {
    return (
        <>
            <section className={styles.top_banner} style={{ backgroundImage: `url(${props.bgImage})` }} >
                <div className={styles.banner_text}>
                    <div className='container common_title text-center'>
                        <h1>{props.title}</h1>
                    </div>
                </div>
            </section>
        </>
    )
}
